// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reservasV2-date-picker .vc-day-content[data-v-4420d078]:hover {\r\n    background-color: var(--spainhn-rojo-grisaceo) !important;\r\n    color: #fff;\n}\n.loader-component {\r\n    position: fixed;\r\n    bottom: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 100;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
